import axios from 'axios';
import { BASE_URL } from '../../constants/apiPaths';
import { getAccessToken } from '../../firebase';
import { toast } from 'sonner';
const getConfig = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};

// Endpoint: PATCH /citizen?walletAddress=<solana_address> OR PATCH /citizen?evmAddress=<evm_address></evm_address>
export const updateWallet = async (evmAddress, walletAddress) => {
    try {
        const url = `${BASE_URL}/citizen?${evmAddress ? `evmAddress=${evmAddress}` : `walletAddress=${walletAddress}`}`;

        const accessToken = await getAccessToken();

        const response = await axios.patch(url, {}, getConfig(accessToken));

        if (response.status === 201 || response.status === 200) return response.data;
    } catch (error) {
        return error;
        // toast.error('Sorry unable to create your organization.');
    }
};

// Endpoint: GET /citizen/primaryPill

// Endpoint: PUT /citizen/primaryPill
